import { formatLedgerAmount } from '@/features/security-ledger/lib/format'

interface BalancePreviewProps {
  currentBalance: number
  /** The entered amount; may be undefined/NaN while typing. */
  delta: number | undefined
  direction: 'increase' | 'decrease'
  currency: string
}

/** Shows "Current → Balance after" so the actor sees the effect before submitting. */
export function BalancePreview({
  currentBalance,
  delta,
  direction,
  currency,
}: BalancePreviewProps): React.ReactElement {
  const valid = typeof delta === 'number' && Number.isFinite(delta) && delta > 0
  const projected = valid
    ? direction === 'increase'
      ? currentBalance + delta
      : currentBalance - delta
    : currentBalance

  return (
    <div className="flex items-center justify-between rounded-md bg-gray-50 px-3 py-2 text-sm dark:bg-gray-800/50">
      <span className="text-gray-500 dark:text-gray-400">Balance after</span>
      <span className="flex items-center gap-2">
        <span className="text-gray-400 line-through dark:text-gray-500">
          {formatLedgerAmount(currentBalance, currency)}
        </span>
        <span aria-hidden className="text-gray-400">→</span>
        <span className="font-semibold text-gray-900 dark:text-gray-100">
          {formatLedgerAmount(projected, currency)}
        </span>
      </span>
    </div>
  )
}

BalancePreview.displayName = 'BalancePreview'
